export const ActionTypes = {
    LOG_IN: 'LOG_IN',
    UPDATE_LOADING_SCREEN: 'UPDATE_LOADING_SCREEN',
    SHOW_ALERT: 'SHOW_ALERT',
    CITY_List: 'CITY_List',
    GUEST_TYPE_LIST: 'GUEST_TYPE_LIST',
    AGENT_LIST: 'AGENT_LIST',
    BRANCH_LIST: 'BRANCH_LIST',
    BRANCH_USER_LIST: 'BRANCH_USER_LIST',
    PICKUP_LOCATION_LIST: 'PICKUP_LOCATION_LIST',
    DROPOFF_LOCATION_LIST: 'DROPOFF_LOCATION_LIST',
    BKG_COLOR: 'BKG_COLOR',
    SUB_ROUTES_CITY: 'SUB_ROUTES_CITY',
    BUSES_LIST_ALL: 'BUSES_LIST_ALL',
    DRIVER_LIST_ALL: 'DRIVER_LIST_ALL',
    CONDUCTOR_LIST_ALL: 'CONDUCTOR_LIST_ALL',
    PICKUP_MAN_LIST_ALL: 'PICKUP_MAN_LIST_ALL',
    USER_DETAILS: 'USER_DETAILS',
    TRIP_LIST: 'TRIP_LIST',
    PAYMENT_MODE: 'PAYMENT_MODE',
    AMENITIES_LIST: 'AMENITIES_LIST',
    USER_ROLE: 'USER_ROLE',
    BKG_COUNT: 'BKG_COUNT',
    COMP_LIST_ALL: 'COMP_LIST_ALL',
};

export default ActionTypes;
